<template>
    <div class="flex justify-center">
        <transition name="slide-swap">
            <keep-alive include="players-table">
                <router-view id="myrouter"></router-view>
            </keep-alive>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'players-main',
    components: {},
    data() {
        return {}
    },
    computed: {},
    watch: {},
    methods: {}
}
</script>

<style scoped>
h2 {
    color: #6a6e6e;
}
</style>
